module.exports = __webpack_public_path__ + "img/128.99f3c5fb.jpg";